import { NAV_LINKS, SITE_NAME, SITE_PHONE_DISPLAY, SITE_PHONE_HREF } from "@/lib/site";

export function SiteHeader() {
  return (
    <header className="sticky top-0 z-50 border-b border-border/60 bg-background/85 backdrop-blur-md">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-3 px-4 py-3 sm:px-6">
        <a
          href="/"
          className="flex min-w-0 items-center gap-3 rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        >
          <img
            src="/logo-96.webp"
            srcSet="/logo-96.webp 96w, /logo.webp 192w"
            sizes="48px"
            alt=""
            width={48}
            height={59}
            decoding="async"
            className="h-12 w-12 object-contain"
          />
          <span className="min-w-0">
            <span className="block font-display text-sm leading-none text-navy sm:text-lg">
              {SITE_NAME}
            </span>
            <span className="mt-0.5 block text-[10px] uppercase tracking-widest text-muted-foreground sm:text-xs">
              Window Installation Experts
            </span>
          </span>
        </a>

        <nav aria-label="Primary" className="flex shrink-0 items-center gap-2 sm:gap-3">
          <ul className="hidden items-center gap-5 lg:flex">
            {NAV_LINKS.filter((l) => l.href !== "/#quote").map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  className="text-sm font-semibold text-navy transition hover:text-primary-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>

          <details className="relative lg:hidden">
            <summary className="flex min-h-11 min-w-11 cursor-pointer list-none items-center justify-center rounded-md border border-border px-3 text-sm font-semibold text-navy marker:content-none [&::-webkit-details-marker]:hidden">
              Menu
            </summary>
            <ul className="absolute right-0 z-50 mt-2 min-w-44 rounded-md border border-border bg-background p-2 shadow-sharp">
              {NAV_LINKS.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="block rounded px-3 py-2 text-sm font-semibold text-navy hover:bg-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </details>

          <a
            href={SITE_PHONE_HREF}
            className="inline-flex min-h-11 items-center justify-center rounded-md border border-border px-3 py-2 text-sm font-semibold text-navy transition hover:border-primary hover:text-primary-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          >
            <span className="sm:hidden">Call</span>
            <span className="hidden sm:inline">{SITE_PHONE_DISPLAY}</span>
          </a>
          <a
            href="#quote"
            className="inline-flex min-h-11 items-center justify-center rounded-md bg-gradient-primary px-4 py-2.5 text-sm font-bold uppercase tracking-wide text-navy shadow-sharp transition hover:translate-y-[-1px] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
          >
            Free Quote
          </a>
        </nav>
      </div>
    </header>
  );
}
